/**
 * Conversión entre euros y dólares con el tipo de cambio del proveedor.
 *
 * El resultado se redondea a entero, no a 2 decimales: la conversión no se guarda
 * en BD y se recalcula al leer, así que tiene que dar lo mismo que cuando se creó
 * la venta (90 $ -> 85 €, no 85,14 €). Debe coincidir con el `ROUND(x, 0)` de las
 * vistas y con `roundCambio` del backend. Los importes que ya están en su moneda
 * siguen con 2 decimales (ver `src/utils/money.ts`).
 */
export const obtenerPrecioEuros = (precioDolares, cambioEuros, cambioDolares) => {
  if (!cambioEuros) return 0;
  return Math.round((precioDolares * cambioDolares) / cambioEuros);
};

export const obtenerPrecioDolares = (precioEuros, cambioEuros, cambioDolares) => {
  if (!cambioDolares) return 0;
  return Math.round((precioEuros * cambioEuros) / cambioDolares);
};
